/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Chip,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';

export const CHART_HEIGHT = 320;
export const FOCUS_CHART_HEIGHT = 520;
export const CHART_HEIGHT_RANKING = 320;
export const RANKING_INLINE_MAX_HEIGHT = 300;
export const RANKING_ROW_HEIGHT = 36;

/** Legenda compacta à direita para gráficos empilhados horizontais (9 categorias). */
export const STACKED_CHART_LEGEND_SIDE = {
  direction: 'column',
  position: { vertical: 'middle', horizontal: 'end' },
  padding: 0,
  itemMarkWidth: 10,
  itemMarkHeight: 10,
  markGap: 4,
  itemGap: 4,
  labelStyle: { fontSize: 11 },
};

export const toggleLocalCategoria = (current, next) =>
  (current && next && current === next ? null : next) || null;

export const LocalFilterChip = ({ label, onClear }) => {
  if (!label) return null;
  return (
    <Chip
      size="small"
      color="primary"
      variant="outlined"
      label={label}
      onDelete={onClear}
      sx={{ mb: 1 }}
    />
  );
};

LocalFilterChip.propTypes = {
  label: PropTypes.string,
  onClear: PropTypes.func.isRequired,
};

LocalFilterChip.defaultProps = {
  label: null,
};

export const ChartEmpty = ({ message }) => (
  <Box
    sx={{
      height: CHART_HEIGHT,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'text.secondary',
      gap: 1,
    }}
  >
    <BarChartOutlinedIcon sx={{ fontSize: 40, opacity: 0.4 }} />
    <Typography variant="body2">{message}</Typography>
  </Box>
);

ChartEmpty.propTypes = {
  message: PropTypes.string.isRequired,
};

export const ChartCard = ({ title, action, onExpand, contentSx, children }) => (
  <Card variant="outlined" sx={{ borderRadius: 2, height: '100%' }}>
    <CardHeader
      title={title}
      titleTypographyProps={{ variant: 'h6' }}
      action={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          {action}
          {onExpand && (
            <Tooltip title="Expandir">
              <IconButton size="small" onClick={onExpand} aria-label="Expandir gráfico">
                <OpenInFullIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      }
      sx={{ pb: 0 }}
    />
    <CardContent sx={{ pt: 1, pb: 2, ...contentSx }}>{children}</CardContent>
  </Card>
);

ChartCard.propTypes = {
  title: PropTypes.string.isRequired,
  action: PropTypes.node,
  onExpand: PropTypes.func,
  contentSx: PropTypes.object,
  children: PropTypes.node.isRequired,
};

ChartCard.defaultProps = {
  action: null,
  onExpand: null,
  contentSx: null,
};
